import {createSlice} from '@reduxjs/toolkit';
import {REHYDRATE} from 'redux-persist';
import {changeAuth0Client} from '../../nativeModules/Auth0';

export interface ISettingsState {
  env: string;
}

export const initialState: ISettingsState = {
  env: 'PROD',
};

const settingsSlice = createSlice({
  name: 'settings',
  initialState,
  reducers: {
    setEnvironment(state, action) {
      state.env = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(REHYDRATE, (state, action: any) => {
      changeAuth0Client(action.payload?.settings?.env);
    });
  },
});

export const {setEnvironment} = settingsSlice.actions;
export default settingsSlice.reducer;
